<template>
  <div>
    <h3>角色名称：{{ describe }}</h3>
    <el-tree
      :props="child"
      show-checkbox
      :data="treeListData"
      node-key="key"
      :default-expanded-keys="['0']"
      :default-checked-keys="checkedArr"
      @check="handleCheckChange"
    />
  </div>
</template>

<script>
import { TreeLoop } from '@/assets/site'
export default {
  props: {
    treeData: {
      type: Object,
      default: () => {}
    }
  },
  data: function() {
    return {
      child: {
        children: 'fChildrens',
        label: 'describe'
      },
      describe: '',
      treeListData: [],
      checkedArr: []
    }
  },
  // watch: {
  //   treeListData: {
  //     handler(val) {
  //       console.log(val, "val");
  //     },
  //     deep: true,
  //   },
  // },
  mounted() {
    // console.log(this.treeData, 'data')
    this.treeListData = [this.treeData.roleGrant]
    this.describe = this.treeData.fName

    TreeLoop(
      this.treeListData,
      (node) => {
        if (node.isGrant) {
          this.checkedArr.push(node.key)
        }
      },
      'fChildrens'
    )
  },
  methods: {
    submit: function(onValid, onSuccess, onFailed, onComplete) {
      onValid(this.treeData)
    },

    handleCheckChange(data, checked, indeterminate) {
      // console.log(data, checked, indeterminate);
      data.isGrant = !data.isGrant
      const decide = data.isGrant
      // console.log(decide);
      this.fun(data, decide)
    },
    fun(data, decide) {
      var forFn = function(data, decide) {
        if (data.fChildrens.length > 0) {
          data.fChildrens.forEach((v) => {
            // console.log('v', v)
            v.isGrant = decide
            if (v.fChildrens.length > 0) {
              forFn(v, decide)
            }
          })
        } else return
      }
      forFn(data, decide)
    }
  }
}
</script>

<style>
</style>
